import {
  TOGGLE_FAV_TAG,
  TOGGLE_THUMBNAIL,
  SHOW_OBJECT_PROPERTY,
  SHOW_KEYBOARD_SHORTCUT,
  SET_SELECTED_TAG,
  SET_SELECTED_READING_ORDER,
  SET_SELECTED_ROWSPAN,
  SET_SELECTED_COLSPAN,
  SET_SELECTED_SCOPE,
  SET_SELECTED_LEFT_DISTANCE,
  SET_SELECTED_TOP_DISTANCE,
  SET_SELECTED_WIDTH_DISTANCE,
  SET_SELECTED_HEIGHT_DISTANCE,
  SET_SELECTED_ZONE_COORDINATES,
  TOGGLE_REPORT,
  TOGGLE_TAGGING_MODE,
  TOGGLE_DOCUMENT_METADATA,
  TOGGLE_ALT_TEXT,
  TOGGLE_BOOKMARKS,
  TOGGLE_DOC_TAG_TRAY,
  VALIDATION_REPORT_DATA,
  VIEW_BOOKMARKS,
  BOOKMARK_UPDATE,
  UPDATE_JSON_BOOKMARK,
  THUMBNAIL,
  PAGE_DETAILS,
  METADATA_DETAILS,
  FIG_ALT_TEXT_DATA,
  TAB_ALT_TEXT_DATA,
  FOR_ALT_TEXT_DATA,
  THUMBNAIL_ALT_TEXT,
  UPDATE_ALT_TEXT,
  UPDATE_ALT_TEXT_STATE,
  AUTO_MATH_API,
  SHOW_TAGS,
  SHOW_READING_ORDER,
  SHOW_ZONE,
  PREV_PAGE,
  NEXT_PAGE,
  PAGE_FULL_IMAGE,
  GOTO_PAGE,
  UPDATE_TEMP_PAGENO,
  SET_ZOOM_PERCENT,
  SET_UNDO_EVENT,
  SET_UNDO_STACK,
  SET_REDO_EVENT,
  APPLY_MATH_TEXT,
  SET_TAGGING_MODE,
  SAVE_NOW,
  SAVE_MANUAL,
  SET_CAN_DRAG,
  SET_CAN_DRAW_TAG,
  SET_CURRENT_TAG_VALUE,
  SET_NEW_COORDINATES,
  SET_NEW_ALTFOR,
  SET_NEW_ALTFIG,
  SET_NEW_ALTTAB,
  APPLY_ALT_FILTER,
  SET_TABLE_OPR_VISIBILITY,
  SET_MERGE_OPR_VISIBILITY,
  SET_LIST_OPR_VISIBILITY,
  SET_ZONE_OPR_VISIBILITY,
  SET_TOC_OPR_VISIBILITY,
  SET_DRAW_ROW,
  SET_DRAW_COLUMN,
  SET_DELETE_ROW,
  SET_DELETE_COLUMN,
  SET_MERGE_CELLS,
  CLEAR_READING_ORDER,
  CLEAR_ZONES,
  AUTO_REORDER,
  MANUAL_ORDER,
  APPLY_ORDER,
  END_ORDER,
  ADD_READING_ORDER,
  SET_LAST_READING_ORDER,
  SET_CLEAR_CELLS,
  SET_DELETE_CELLS,
  FINISH_TAGGING,
  FINISH_TASK,
  COMPLETE_REVIEW,
  SET_REVIEW_COMPLETE,
  SET_TABLE_TAG_GENERATED,
  SET_ZONE_MERGED,
  SET_TOC_CREATE,
  SET_ZONE_DELETE,
  CREATE_IMG,
  DELETE_IMG,
  BULK_DELETE_IMG,
  VIEWER_TAGS,
  SELECTED_ZONE,
  SET_SELECTED_LINKTYPE,
  SET_SELECTED_HREF,
  SET_SELECTED_FORMFIELD_REQUIRED,
  SET_SELECTED_FORMFIELD_GROUPNAME,
  SET_SELECTED_FORMFIELD_TOOLTIP,
  SET_SELECTED_FORMFIELD_VALUE,
  ALTIMG_CHANGE,
  RESET_ALT_IMG,
  RESET_ALT_IMG_VAL,
  ALT_ONETIME_LOAD,
  RESET_ALT_UPDATE,
  SET_ENABLE_GENERATE_TABLE,
  SET_ENABLE_MERGE_CELLS,
  SET_SELECTED_TAG_ID,
  ADD_IN_COMPLETE_TABLE,
  REMOVE_IN_COMPLETE_TABLE,
  IMAGE_LOADING_STATUS,
  FOCUS_THUMBNAILS,
  RESET_OBJ_PROPERTY,
  SELECTED_ZONE_VALUE,
  SAVE_DOC_VALUE,
  SHOW_METADATA_ALERT,
  SET_APPLY_FLAG,
  SET_THUMBNAIL_FOCUS,
  SET_BOOKMARK_TI,
  SET_BK_TRAY_TI,
  SET_DOC_TAG_TI,
  SET_DOC_TAG_TRAY_TI,
  SET_REPORT_TI,
  SET_VR_TRAY_TI,
  SET_TOPBAR_TI,
  PROCESS_IMG_FLAG,
  SET_DOC_DETAILS_TI,
  SET_DOC_DETAILS_TRAY_TI,
  SET_TAG_TI,
  SET_TAG_TRAY_TI,
  UPDATE_READ_ORDER,

} from '../actions/EditorActions'

import { TAGGING_MODE_SINGLE, TAGGING_MODE_CONTINUOUS } from 'src/components/Editor/constants'

import {
  RIGHT_TAB_ALT_TEXT,
  RIGHT_TAB_DOC_META,
  RIGHT_TAB_FAV,
  RIGHT_TAB_TAGGINGMODE,
  RIGHT_TAB_REPORT,
  RIGHT_TAB_BOOKMARK,
  RIGHT_TAB_DOCTAGTRAY,
  MANUAL_ORDER_STEP_1,
  MANUAL_ORDER_STEP_2,
  MANUAL_ORDER_STEP_3,
} from 'src/components/Editor/constants'

const initialState = {
  showThumbnail: false,
  bookmarkUpdated: undefined,
  showObjectProperty: false,
  showFavouriteTags: false,
  activeRightTab: '',
  showTagTray:false,
  showBookmarks:false,
  showReport:false,
  bookmarks: undefined,
  bookmarksOld: undefined,
  bookmarkCount: 0,
  thumbnail: new Map(),
  altThumbnail: new Map(),
  altImgUUID: [],
  altImgLoadUUID: [],
  recentAltUpdated:[],
  loadedPage: undefined,
  altloadedimage: undefined,
  currentPage: 1,
  fullPageImage: undefined,
  zoomLevel: 1,
  applyMath: false,
  applyAltFilterTxt: '',
  taggingMode: TAGGING_MODE_SINGLE,
  savePage: false,
  canDrag: false,
  canDrawTag: false,
  currenttagValue: '',
  newCoordinates: [],
  undoEvent: undefined,
  undoStackValue: {},
  manual_order_step: MANUAL_ORDER_STEP_1,
  orderFlag: false,
  lastReadingOrder: 0,
  selectedTag: '',
  selectedRO: '',
  selectedLD: '',
  selectedTD: '',
  selectedWD: '',
  selectedHD: '',

  clearCells: false,
  deleteCells: false,
  startTagging: false,
  finishTask: false,
  altImgChgUpdate:'',
  bulkAltImgChgUpdate: 0,
  
  delImgAction: false,
  altOneTimeLoad: true,
  pageWidth: 0,
  pageHeight:0,
}

let i=1;
const EditorReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_CLEAR_CELLS:
      state = {
        ...state,
        clearCells: action.payload,
      }
      break
    case SET_DELETE_CELLS:
      state = {
        ...state,
        deleteCells: action.payload,
      }
      break
    case MANUAL_ORDER:
      let maxOrder  = Math.max(...state.newCoordinates.filter(o => o.reading_order).map((o) => o.reading_order), 0)
      console.log("max Order ",maxOrder)
      state = {
        ...state,
        orderFlag: true,
        manual_order_step: MANUAL_ORDER_STEP_2,
        lastReadingOrder: maxOrder,
      }
      break

    case END_ORDER:
      state = {
        ...state,
        orderFlag: false,
        manual_order_step: MANUAL_ORDER_STEP_3,
      }
      break

    case APPLY_ORDER:
      state = {
        ...state,
        orderFlag: false,
        manual_order_step: MANUAL_ORDER_STEP_1,
      }
      break

    case CLEAR_READING_ORDER:
      const cleared_order_coords = state.newCoordinates.map((coor) => {
        delete coor['reading_order']
        return coor
      })
      state = {
        ...state,
        lastReadingOrder: 0,
        newCoordinates: [...cleared_order_coords],
      }
      break
    case CLEAR_ZONES:
      state = {
        ...state,
       /*  newCoordinates: [],
        lastReadingOrder: 0, */
        isZonesCleared:action.payload
      }
      break
      
    case AUTO_REORDER:
      console.log("List Data ::: Reordering ....",state.newCoordinates);
      // const parent_coords = Object.assign([], state.newCoordinates)
      // .filter((parent) => parent.parent_id.length==1)
      // .sort((a, b) => (a.ymin == b.ymin ? a.xmin - b.xmin : a.ymin - b.ymin))
      
      const auto_reordered_coords =sortArray( state.newCoordinates.sort((a, b) => (a.ymin == b.ymin ?   a.xmin - b.xmin : a.ymin - b.ymin )))
      console.log('List Data ::: sorted array',auto_reordered_coords);
      
      state = {
        ...state,
        lastReadingOrder: Math.max(...auto_reordered_coords.filter(o => o.reading_order).map((o) => o.reading_order), 0),
        newCoordinates: [...auto_reordered_coords],
      }
      break
    case ADD_READING_ORDER:
      const newCoords = state.newCoordinates.map((c, i) => {
        if (c['id'] === action.payload) {
          c['reading_order'] = state.lastReadingOrder + 1
        }
        return c
      })
      state = {
        ...state,
        lastReadingOrder: state.lastReadingOrder + 1,
        newCoordinates: [...newCoords],
      }
      break
    case SET_LAST_READING_ORDER:
      state = {
        ...state,
        lastReadingOrder: Math.max(action.payload, 0),
      }
      break
    case TOGGLE_THUMBNAIL:
      state = {
        ...state,
        canDrawTag: false,
        showThumbnail: !state.showThumbnail,
        showBookmarks:false,
        showTagTray:false,
        showReport:false
      }
      break

      /* case TOGGLE_TAG_TRAY:
        state = {
          ...state,
          canDrawTag: false,
          showTagTray: !state.showTagTray,
          showThumbnail:false
      
        }
        break */
    case SHOW_OBJECT_PROPERTY:
      if(action.payload){
        state = {
          ...state,
          showThumbnail: false,
          showObjectProperty: action.payload,
          activeRightTab: "ObjectProperty"
        }
      }else{
        state = {
          ...state,
          showThumbnail: false,
          showObjectProperty: action.payload,
          activeRightTab: ""
        }
      }
      
      break
      case SHOW_KEYBOARD_SHORTCUT:
      state = {
        ...state,
        showKeyBoardShortcut: action.payload,
      }
      break
    case SET_SELECTED_TAG:
      state = {
        ...state,
        selectedTag: action.payload,
       // altImgChgUpdate: action.payload,
      }
      break
    case SET_SELECTED_READING_ORDER:
      state = {
        ...state,
        selectedRO: action.payload,
      }
      break
    case SET_SELECTED_ROWSPAN:
      state = {
        ...state,
        selectedRspan: action.payload,
      }
      break
    case SET_SELECTED_SCOPE:
      state = {
        ...state,
        selectedTDScope: action.payload,
      }
      break
    case SET_SELECTED_LINKTYPE:
      state = {
        ...state,
        selectedLnkType: action.payload,
      }
      break
    case SET_SELECTED_HREF:
      state = {
        ...state,
        selectedLnkHref: action.payload,
      }
      break
    case SET_SELECTED_FORMFIELD_REQUIRED:
      state = {
        ...state,
        selectedFDRq: action.payload,
      }
      break
    case SET_SELECTED_FORMFIELD_GROUPNAME:
      state = {
        ...state,
        selectedFDGName: action.payload,
      }
      break
    case SET_SELECTED_FORMFIELD_TOOLTIP:
      state = {
        ...state,
        selectedFDTtip: action.payload,
      }
      break
    case SET_SELECTED_FORMFIELD_VALUE:
      state = {
        ...state,
        selectedFDVal: action.payload,
      }
      break
    case SET_SELECTED_COLSPAN:
      state = {
        ...state,
        selectedCspan: action.payload,
      }
      break
    case SET_SELECTED_LEFT_DISTANCE:
      state = {
        ...state,
        selectedLD: action.payload,
      }
      break
    case SET_SELECTED_TOP_DISTANCE:
      state = {
        ...state,
        selectedTD: action.payload,
      }
      break
    case SET_SELECTED_WIDTH_DISTANCE:
      state = {
        ...state,
        selectedWD: action.payload,
      }
      break
    case SET_SELECTED_HEIGHT_DISTANCE:
      state = {
        ...state,
        selectedHD: action.payload,
      }
      break
    case SET_SELECTED_ZONE_COORDINATES:
      state = {
        ...state,
        selectedZoneCD: action.payload,
      }
      break
    case APPLY_MATH_TEXT:
      state = {
        ...state,
        applyMath: action.payload,
      }
      break
    case APPLY_ALT_FILTER:
      state = {
        ...state,
        applyAltFilterTxt: action.payload,
      }
      break
    case TOGGLE_FAV_TAG:
      state = {
        ...state,
      //  canDrawTag: state.activeRightTab == RIGHT_TAB_FAV ? false : true,
        showObjectProperty:false,
        activeRightTab: state.activeRightTab == RIGHT_TAB_FAV ? '' : RIGHT_TAB_FAV,
      }
      break
    case TOGGLE_REPORT:
      console.log('Reducer Editor ->', action.type)
      state = {
        ...state,
        canDrawTag: false,
        showThumbnail: false,
        showBookmarks:false,
        showTagTray:false,
        showReport:!state.showReport
        //activeRightTab: state.activeRightTab == RIGHT_TAB_REPORT ? '' : RIGHT_TAB_REPORT,
      }
      break
    case TOGGLE_BOOKMARKS:
      console.log('Reducer Editor ->', action.type)
    /*   state = {
        ...state,
        canDrawTag: false,
        bookmarks:undefined,
        activeRightTab: state.activeRightTab == RIGHT_TAB_BOOKMARK ? '' : RIGHT_TAB_BOOKMARK,
      } */
      state = {
        ...state,
        canDrawTag: false,
        showBookmarks: !state.showBookmarks,
        showThumbnail:false,
        showTagTray:false,
        showReport:false
      }
      break
    case TOGGLE_DOCUMENT_METADATA:
      console.log('Reducer Editor ->', action.type)
      state = {
        ...state,
        canDrawTag: false,
        showObjectProperty:false,
        activeRightTab: state.activeRightTab == RIGHT_TAB_DOC_META ? '' : RIGHT_TAB_DOC_META,
      }
      break
    case TOGGLE_ALT_TEXT:
      console.log('Reducer Editor ->', action.type)
      state = {
        ...state,
        canDrawTag: false,
        showObjectProperty:false,
        activeRightTab: state.activeRightTab == RIGHT_TAB_ALT_TEXT ? '' : RIGHT_TAB_ALT_TEXT,
      }
      break

    case TOGGLE_DOC_TAG_TRAY:
      console.log('Reducer doc tray ->', action.type)
      
     /*  state = {
        ...state,
        canDrawTag: false,
        activeRightTab: state.activeRightTab == RIGHT_TAB_DOCTAGTRAY ? '' : RIGHT_TAB_DOCTAGTRAY,
      }
      break */
      state = {
        ...state,
        canDrawTag: false,
        showTagTray: !state.showTagTray,
        showThumbnail:false,
        showBookmarks:false,
        showReport:false
      }
      break

    case TOGGLE_TAGGING_MODE:
      state = {
        ...state,
        //canDrawTag: false,
        showObjectProperty:false,
        activeRightTab: state.activeRightTab === RIGHT_TAB_TAGGINGMODE ? '' : RIGHT_TAB_TAGGINGMODE,
      }
      break

    case VALIDATION_REPORT_DATA:
      state = {
        ...state,
        validationReport: action.payload,
      }
      break

    case VIEW_BOOKMARKS:
      console.log('Bookmarks received :: 123', action.payload)
      state = {
        ...state,
        bookmarkUpdated: undefined,
        bookmarksOld: {...action.payload},
        bookmarks: {...action.payload},
        bookmarkCount: state.bookmarkCount + 1,
        
      }
      break
    case BOOKMARK_UPDATE:
      state = {
        ...state,
        bookmarkUpdated: action.payload,
      }
      break

    case UPDATE_JSON_BOOKMARK:
      state = {
        ...state,
        bookmarksOld: {...action.payload},
        bookmarks: {...action.payload},
        bookmarkCount: state.bookmarkCount+1,
        
      }
      break

    case THUMBNAIL:
      let thumb = state.thumbnail
      thumb.set(action.payload.pageNo, action.payload.url)

      state = {
        ...state,
        thumbnail: thumb,
        loadedPage: action.payload.pageNo,
      }
      break

    case THUMBNAIL_ALT_TEXT:
     // console.log('ALT Thumb :', action.payload, state)
      let thumbForAlt = state.altThumbnail
      // let temp=state.altImgUUID
      // let x = Array.from(temp.entries(), ([key, value]) => value);
      // if(x.indexOf(action.payload.identifier) == -1) 
      // temp.push({'uuid': action.payload.identifier})
      thumbForAlt.set(action.payload.identifier, action.payload.url)
      state.altImgLoadUUID= [...state.altImgLoadUUID, action.payload.identifier],
      state = {
        ...state,
        altThumbnail: thumbForAlt,
        altloadedimage: action.payload.identifier,
        altImgLoadUUID: state.altImgLoadUUID,
      }
      break

    case UPDATE_ALT_TEXT:
      state = {
        ...state,
        updateAltTxt: action.payload,

      }
      console.log("XXX-updateAltText", state)
      break
    case UPDATE_ALT_TEXT_STATE:
      state.recentAltUpdated= [...state.recentAltUpdated, action.payload.imgName],
      state={
        ...state,
        lastAltUpdate:action.payload,
      } 
      if(state.lastAltUpdate.type=='Fig') {
        state.figAltText=updateAlts(state.figAltText, state.lastAltUpdate.uniqueIdentifier, action.payload.longDes)
        state.figEmptyFlag=findEmptyAlt(state.figAltText);
      }
      if(state.lastAltUpdate.type=='For') {
        state.forAltText=updateAlts(state.forAltText, state.lastAltUpdate.uniqueIdentifier, action.payload.longDes)
        state.forEmptyFlag=findEmptyAlt(state.forAltText);
      }
      if(state.lastAltUpdate.type=='Table') {
        state.tabAltText=updateAlts(state.tabAltText, state.lastAltUpdate.uniqueIdentifier, action.payload.longDes)
        state.tabEmptyFlag=findEmptyAlt(state.tabAltText);
      }

      console.log("yyy-lastAltUpdateState", state)
      break 
    case AUTO_MATH_API:
      state = {
        ...state,
        autoMathApi: action.payload,
      }
      break
    case PAGE_FULL_IMAGE:
      state = {
        ...state,
        fullPageImage: action.payload,
      }
      break
    case SHOW_TAGS:
      state = {
        ...state,
        showTags: action.payload,
      }
      break
    case SHOW_READING_ORDER:
      state = {
        ...state,
        showRo: action.payload,
      }
      break
    case SHOW_ZONE:
      state = {
        ...state,
        showZone: action.payload,
      }
      break

    case PREV_PAGE:
      state = {
        ...state,
        currentPageTemp: state.currentPage,
        currentPage: state.currentPage > 1 ? --state.currentPage : 1,
        overlapCheckRequired: true,
      }
      break
    case NEXT_PAGE:
      state = {
        ...state,
        currentPageTemp: state.currentPage,
        currentPage:
        state.currentPage < state.total_page_count ? ++state.currentPage : state.total_page_count,
        overlapCheckRequired: true,
      }
      break
    case GOTO_PAGE:
      state = {
        ...state,
        currentPage: action.payload.pageNo,
        overlapCheckRequired : action.payload.overlapCheckRequired,
      }
      break
    case UPDATE_TEMP_PAGENO:
      state = {
        ...state,
        currentPageTemp: action.payload,
      }
      break
    case SET_ZOOM_PERCENT:
      state = {
        ...state,
        zoomLevel: action.payload,
      }
      break

    case SET_UNDO_EVENT:
      state = {
        ...state,
        undoEvent: action.payload,
        activeRightTab: ""
      }
      break

    case SET_REDO_EVENT:
      state = {
        ...state,
        redoEvent: action.payload,
        activeRightTab: ""
      }
      break

    case SET_UNDO_STACK:
      state = {
        ...state,
        undoStackValue: action.payload,
      }
      break

    case SAVE_NOW:
      state = {
        ...state,
        savePage: action.payload,
      }
      break

    case SAVE_MANUAL:
      state = {
        ...state,
        saveManual: action.payload,
      }
    break      

    case PAGE_DETAILS:
      //let x=action.payload?.coordinates;
      let x=fixParentId(action.payload)
      //console.log('Page load :', x, action.payload)
      state = {
        ...state,
         //pageDetails: action.payload,
        pageDetails: x,
        total_page_count: action.payload?.total_page_count,
        pageWidth: action.payload?.page_width,
        pageHeight: action.payload?.page_height,
      }
      break

    case VIEWER_TAGS:
      state = {
        ...state,
        viewerTagList: action.payload,
      }
      break
    case CREATE_IMG:
      console.log('Page load :', action.payload, state.currenttagValue, action.payload?.total_page_count, state)
      state = {
        ...state,
        createImg: action.payload,
        altImgChgUpdate: state.currenttagValue,
      }
      if(state.figAltText!=undefined) state.figEmptyFlag=findEmptyAlt(state.figAltText);
      if(state.forAltText!=undefined) state.forEmptyFlag=findEmptyAlt(state.forAltText);
      if(state.tabAltText!=undefined) state.tabEmptyFlag=findEmptyAlt(state.tabAltText);

      
      console.log("stateUpdate-creteImg", state)
      break
    case DELETE_IMG:
      console.log('Page load :', action.payload, state.currenttagValue, action.payload?.total_page_count)
      state = {
        ...state,
        delImg: action.payload,
        altImgChgUpdate: state.currenttagValue,
      }
      console.log("stateUpdate-delImg", state)
      if(action.payload) state.bulkAltImgChgUpdate++;
      break
    case BULK_DELETE_IMG:
      console.log('BULK_DELETE_IMG :', action.payload, state.currenttagValue, action.payload?.total_page_count)
      //if(action.payload) bulkAltImgChgUpdate++,
      state = {
        ...state,
        delImg: action.payload,
        //bulkAltImgChgUpdate: bulkAltImgChgUpdate+1,
      }
     // console.log("bulkAltImgChgUpdate", state,)

      if(action.payload){
        state.bulkAltImgChgUpdate++;
        if(state.forEmptyFlag==true) state.forEmptyFlag=false;
        if(state.tabEmptyFlag==true) state.tabEmptyFlag=false;
        if(state.figEmptyFlag==true) state.figEmptyFlag=false;
      }
      //console.log("bulkAltImgChgUpdate11111", state, state.bulkAltImgChgUpdate)
      break


      case PROCESS_IMG_FLAG :
        state = {
          ...state,
          processImgData: action.payload,
        }
      break      
      case RESET_ALT_IMG:
        
        state = {
          ...state,
          altImgChgUpdate: "",
        }
        
        break
    case RESET_ALT_IMG_VAL:
        
        state = {
          ...state,
          altImgChgUpdate: action.payload,
        }
        
        break
        case RESET_ALT_UPDATE:
        
        state = {
          ...state,
          updateAltTxt: "",
        }
        
        break

        case ALT_ONETIME_LOAD:
        
        state = {
          ...state,
          altOneTimeLoad: action.payload,
        }
        
        break

    case METADATA_DETAILS:
      state = {
        ...state,
        fileMetadata: action.payload,
      }
      break
    case FIG_ALT_TEXT_DATA:
      state = {
        ...state,
        figAltText: action.payload,
      }
      if(state.figAltText!=undefined) state.figEmptyFlag=findEmptyAlt(state.figAltText);
      break
    case FOR_ALT_TEXT_DATA:
      state = {
        ...state,
        forAltText: action.payload,
      }
      if(state.forAltText!=undefined) state.forEmptyFlag=findEmptyAlt(state.forAltText);
      break
    case TAB_ALT_TEXT_DATA:
      state = {
        ...state,
        tabAltText: action.payload,
      }
      if(state.tabAltText!=undefined) state.tabEmptyFlag=findEmptyAlt(state.tabAltText);
      break
    case SET_TAGGING_MODE:
      state = {
        ...state,
        taggingMode: action.payload,
      }
      break
    case SET_CAN_DRAG:
      state = {
        ...state,
        canDrag: action.payload,
      }
      break
    case SET_CAN_DRAW_TAG:
      state = {
        ...state,
        canDrawTag: action.payload,
      }
      break
    case SET_CURRENT_TAG_VALUE:
      state = {
        ...state,
        currenttagValue: action.payload,
      }
      break
    case SET_NEW_COORDINATES:
      //console.log("newCoordinates====999=>",...action.payload)
       
      state = {
        ...state,
        newCoordinates: [...action.payload],
      }
      break

      case SET_NEW_ALTFIG:
        state = {
          ...state,
          figAltText: [...action.payload],
        }
       // console.log("figupdate", state);
      break
      case SET_NEW_ALTFOR:
        state = {
          ...state,
          forAltText: [...action.payload],
        }
      break      
      case SET_NEW_ALTTAB:
        state = {
          ...state,
          tabAltText: [...action.payload],
        }
      break

    case FINISH_TAGGING:
      state = {
        ...state,
        finishTagging: action.payload,
      }
      break
    case FINISH_TASK:
      state = {
        ...state,
        finishTask: action.payload,
      }
      break

    case UPDATE_READ_ORDER:
      state = {
        ...state,
        redord: action.payload,
      }
      break

    case COMPLETE_REVIEW:
      state = {
        ...state,
        completeReviewData: action.payload,
        
        reviewCompleted: action.payload,
      }
      break
    case SET_REVIEW_COMPLETE:
      state = {
        ...state,
        completeReviewFlag: action.payload,
      }
      break

    case SET_TABLE_OPR_VISIBILITY:
      console.log('Table operation visibility', action.payload)
      state = {
        ...state,
        tableOprVisibility: action.payload,
       
        listOprVisibility: action.payload?false:state.listOprVisibility,
        mergeOprVisibility: action.payload?false:state.mergeOprVisibility,
        zoneOprVisibility:action.payload?false:state.zoneOprVisibility,
        tocOprVisibility:action.payload?false:state.tocOprVisibility,

      }
      break

      case SET_MERGE_OPR_VISIBILITY:
      console.log('Merge operation visibility', action.payload)
      state = {
        ...state,
        mergeOprVisibility: action.payload, 
        tableOprVisibility: action.payload?false:state.tableOprVisibility,
        listOprVisibility: action.payload?false:state.listOprVisibility,
        zoneOprVisibility:action.payload?false:state.zoneOprVisibility,
        tocOprVisibility:action.payload?false:state.tocOprVisibility,
        
      }
      break

      case ALTIMG_CHANGE:
        console.log('Alt image createdOrDeleted', action.payload)
        state = {
          ...state,
          altImgChgUpdate: action.payload,
        }
        break      

    case SET_LIST_OPR_VISIBILITY:
      state = {
        ...state,
        listOprVisibility: action.payload,
        tableOprVisibility: action.payload?false:state.tableOprVisibility,
        mergeOprVisibility: action.payload?false:state.mergeOprVisibility,
        zoneOprVisibility:action.payload?false:state.zoneOprVisibility,
        tocOprVisibility:action.payload?false:state.tocOprVisibility,
        
      }
      break
    case SET_ZONE_OPR_VISIBILITY:
      state = {
        ...state,
        zoneOprVisibility: action.payload,
        tableOprVisibility: action.payload?false:state.tableOprVisibility,
        mergeOprVisibility: action.payload?false:state.mergeOprVisibility,
        listOprVisibility:action.payload?false:state.listOprVisibility,
        tocOprVisibility:action.payload?false:state.tocOprVisibility,
      }
      break
    case SET_TOC_OPR_VISIBILITY:
      state = {
        ...state,
        tocOprVisibility: action.payload,
        tableOprVisibility: action.payload?false:state.tableOprVisibility,
        mergeOprVisibility: action.payload?false:state.mergeOprVisibility,
        listOprVisibility:action.payload?false:state.listOprVisibility,
        zoneOprVisibility:action.payload?false:state.zoneOprVisibility,
        
      }
      break      
    case SET_DRAW_ROW:
      console.log('Row drawing visbility:', action.payload)
      state = {
        ...state,
        canDrawRow: action.payload,
      }
      break
    case SET_DRAW_COLUMN:
      console.log('Column drawing visbility:', action.payload)
      state = {
        ...state,
        canDrawColumn: action.payload,
      }
      break
    case SET_DELETE_ROW:
      console.log('Delete row drawing visbility:', action.payload)
      state = {
        ...state,
        canDeleteRow: action.payload,
      }
      break
    case SET_DELETE_COLUMN:
      console.log('Delete Column drawing visbility:', action.payload)
      state = {
        ...state,
        canDeleteColumn: action.payload,
      }
      break
    case SET_TABLE_TAG_GENERATED:
      console.log('setIsTableTagGenerated:', action.payload)
      state = {
        ...state,
        isTableTagGenerated: action.payload,
      }
      break
    case SET_ZONE_MERGED:
        console.log('setIsTableTagGenerated:', action.payload)
        state = {
          ...state,
          isZoneMerged: action.payload,
        }
        break
    case SET_TOC_CREATE:
      console.log('toccreated:', action.payload)
      state = {
        ...state,
        tocCreated: action.payload,
      }
      break        
    case SET_ZONE_DELETE:
          console.log('setIsTableTagGenerated:', action.payload)
          state = {
            ...state,
            isZoneDeleted: action.payload,
          }
          break
    case SELECTED_ZONE:
      console.log('reducer zone', `New_${action.payload}`)
      state = {
        ...state,
        selectedZone: action.payload,
      }
      break

    case SET_MERGE_CELLS:
      console.log('setIsTableTagGenerated:', action.payload)
      state = {
        ...state,
        isMergeCells: action.payload,
      }
      break
      case SET_ENABLE_GENERATE_TABLE:
        console.log('setIsTableTagGenerated:', action.payload)
        state = {
          ...state,
          isGenerateTableEnabled: action.payload,
        }
      break
      case SET_ENABLE_MERGE_CELLS:
        console.log('setIsEnableMergeCellsGenerated:', action.payload)
        state = {
          ...state,
          isMergeCellsEnabled: action.payload,
        }
      break
      case SET_SELECTED_TAG_ID:
      state = {
        ...state,
        selectedTagId: action.payload,
      }
      break
      case ADD_IN_COMPLETE_TABLE:
        state ={
          ...state,
          inCompleteTable : action.payload
        }
        break
      case REMOVE_IN_COMPLETE_TABLE:
        state = {
          ...state,
          inCompleteTable : ''
        }
        break
      case IMAGE_LOADING_STATUS:
        state = {
          ...state,
          imageLoadingStatus: action.payload
        }
        break
      case FOCUS_THUMBNAILS:
        state = {
          ...state,
          focusThumbnailStatus: action.payload
        }
        break
      case RESET_OBJ_PROPERTY:
        state = {
          ...state,
          resetObjectPropertyStatus: action.payload
        }
        break 
      case SELECTED_ZONE_VALUE:
        state = {
          ...state,
          selectedZoneStatus: action.payload
        }
        break
      case SAVE_DOC_VALUE:
        state = {
          ...state,
          saveDocValue: action.payload
        }
        break
      case SHOW_METADATA_ALERT:
          state = {
            ...state,
            showMetadataAlertValue: action.payload
          }
        break
      case SET_APPLY_FLAG:
          state = {
            ...state,
            applyFlagValue: action.payload
          }
        break
      case SET_THUMBNAIL_FOCUS:
          state = {
            ...state,
            thumbnailFocusValue: action.payload
          }
        break
      case SET_BOOKMARK_TI:
          state = {
            ...state,
            bookmarkTiValue: action.payload
          }
        break
      case SET_BK_TRAY_TI:
          state = {
            ...state,
            bKTrayTiValue: action.payload
          }
        break
      case SET_DOC_TAG_TI:
          state = {
            ...state,
            docTagTiValue: action.payload
          }
        break
      case SET_DOC_TAG_TRAY_TI:
          state = {
            ...state,
            dTTrayTiValue: action.payload
          }
        break
      case SET_REPORT_TI:
          state = {
            ...state,
            reportTiValue: action.payload
          }
        break
      case SET_VR_TRAY_TI:
          state = {
            ...state,
            vrTrayTiValue: action.payload
          }
        break
      case SET_TOPBAR_TI:
          state = {
            ...state,
            topBarTiValue: action.payload
          }
        break
      case SET_DOC_DETAILS_TI:
        //debugger;
          state = {
            ...state,
            docDetailsTiValue: action.payload
          }
        break
      case SET_DOC_DETAILS_TRAY_TI:
        state = {
          ...state,
          docDetailsTrayTiValue: action.payload
        }
      break
      case SET_TAG_TI:
        state = {
          ...state,
          tagTiValue: action.payload
        }
      break
      case SET_TAG_TRAY_TI:
        state = {
          ...state,
          tagTrayTiValue: action.payload
        }
      break
      
           
        
    default:
      state = { ...state }
      break
  }
  return state
}


const getFlatArray = (members) => {
  let kids = []
  const flattenCoordinates = members.map((m) => {
    if (m.kids && m.kids.length) {
      kids = [...kids, ...m.kids]
    }
    return m
  })

   flattenCoordinates.concat(kids.length ? getFlatArray(kids) : kids)

   let i=0;
   flattenCoordinates.forEach(item => {
     i++;
     item.reading_order =i;
     item.ro =i;
   })

   console.log('List Data ::: flattenCoordinates', flattenCoordinates)
   return flattenCoordinates;
}



const sortArray = (listData) => {
  console.log('List Data :::', listData)
  var myMap = {}

  let copyOfList = Object.assign([], listData)

  // .sort((a, b) => a.reading_order - b.reading_order)
  // .sort((a, b) => a.pagenumber - b.pagenumber)

  listData.forEach((data) => {
    data.pos=(data.ymin*1000)+data.xmin;
    //Table
    if(data.element_name=="Table") data.pos=data.pos-3;
    if(data.element_name=="TR"||data.element_name=="L") data.pos=data.pos-2;
    if(data.element_name=="TD"||data.element_name=="TH" || data.element_name=="LI") data.pos=data.pos-1;
  })
  listData.sort((a, b)=>  a.pos-b.pos);
  console.log("listData123", listData)

  // listData.forEach((data) => {
  //   let largerRectangle = copyOfList.filter(
  //     (list) =>

  //       list.coordinate?.xmin <= data.coordinate?.xmin &&
  //       list.coordinate?.ymin <= data.coordinate?.ymin &&
  //       list.coordinate?.xmax >= data.coordinate?.xmax &&
  //       list.coordinate?.ymax >= data.coordinate?.ymax &&
  //       list.id != data.id,
  //   )

  //   if (largerRectangle.length > 0) {
  //     //if(largerRectangle.length > 1) console.log("largerRectangle", largerRectangle, data.element_name);
  //     if(!data.parent_id ||data.parent_id!='0' )data.parent_id = largerRectangle[largerRectangle.length - 1].id
  //   } else {
  //     data.parent_id = '0'
  //   }
  // })
  console.log('List Data ::: Parent Id populated',listData);

   

  let i=0;
  listData.forEach(item => {
    i++;
    item.reading_order =i;
    //item.ro =i;
  })
 
  formTree(listData)

  return listData
}



const formTree = (arr = []) => {
  console.log('List Data ::: arr',arr);
  let map = {},
    node,
    res = [],
    i
  for (i = 0; i < arr.length; i += 1) {
    map[arr[i].id] = arr[i]
    arr[i].kids = []
    
  }
  console.log('List Data ::: arr1',arr);

  for (i = 0; i < arr.length; i += 1) {
    node = arr[i]
    if (node.parent_id !== '0') {
      arr[map[node.parent_id]]?.kids.push(node)
    } else {
      res.push(node)
    }
  }
  console.log('List Data ::: Tree',res);
  return getFlatArray( res)
}

/// ALT Text changes
 const updateAlts=(data, id, longDesc)=>{
  if(data.length>0){
    for(let i=0; i < data.length; i++){
      if(data[i].unique_identifier==id)
      {
        data[i].alt_text_long=longDesc;
        data[i].altUpdate=true;
        break;
      } 
    } 
    return data;
  }
 }
 //Alt Text Empty
 const findEmptyAlt=(data)=>{
  if(data.length>0){

    let pgn=0; let xy=1;
    for (let k=0; k < data.length; k++) { // sequence settings
      data[k].page_no != pgn ? xy=1 : xy++;
      data[k].seq1=xy;
      pgn=data[k].page_no;
      //console.log("Teeeee2", data[i])
    }
    for(let i=0; i < data.length; i++){
      if(data[i].alt_text_long=="" || data[i].alt_text_long==null) return true;
    } 

  }
}
const fixParentId=(data)=>{
  if(data.coordinates!=undefined && data.coordinates.length>0){
    let datax=data.coordinates;
    for (let k=0; k < datax.length; k++) {
      let id=datax[k].id;
      let z=datax[k].kids;
      if(z!=undefined && z.length > 0){
        for (let m=0; m < z.length; m++) {
          z[m].parent_id=id;
          z[m].parent_id_dmy=id;
          if(z[m].kids.length > 0) fixParentId(z[m].kids)
        }
      }
    }
    return data;
  }
  else{return data}
}

export default EditorReducer
